import { useEffect, useState } from "react";

const EVT = "cartao-header";
let atual = null;

export const setCartaoHeader = (info) => {
  atual = info;
  window.dispatchEvent(new Event(EVT));
};

export const useCartaoHeader = () => {
  const [info, setInfo] = useState(atual);
  useEffect(() => {
    const h = () => { setInfo(atual); };
    window.addEventListener(EVT, h);
    return () => { window.removeEventListener(EVT, h); };
  }, []);
  return info;
};
